module.exports = __webpack_public_path__ + "static/media/app-store-en.4ddb3742.svg";